/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Количество найденных записей по типам
 * @export
 * @interface RegistryImageSearch200ResponseCounts
 */
export interface RegistryImageSearch200ResponseCounts {
  /**
   *
   * @type {number}
   * @memberof RegistryImageSearch200ResponseCounts
   */
  applications: number
  /**
   *
   * @type {number}
   * @memberof RegistryImageSearch200ResponseCounts
   */
  registry: number
}

/**
 * Check if a given object implements the RegistryImageSearch200ResponseCounts interface.
 */
export function instanceOfRegistryImageSearch200ResponseCounts(
  value: object
): value is RegistryImageSearch200ResponseCounts {
  if (!('applications' in value) || value['applications'] === undefined)
    return false
  if (!('registry' in value) || value['registry'] === undefined) return false
  return true
}

export function RegistryImageSearch200ResponseCountsFromJSON(
  json: any
): RegistryImageSearch200ResponseCounts {
  return RegistryImageSearch200ResponseCountsFromJSONTyped(json, false)
}

export function RegistryImageSearch200ResponseCountsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryImageSearch200ResponseCounts {
  if (json == null) {
    return json
  }
  return {
    applications: json['applications'],
    registry: json['registry'],
  }
}

export function RegistryImageSearch200ResponseCountsToJSON(
  value?: RegistryImageSearch200ResponseCounts | null
): any {
  if (value == null) {
    return value
  }
  return {
    applications: value['applications'],
    registry: value['registry'],
  }
}
